import styled from 'styled-components'

export const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
`
